'use client';

import React, { useState } from "react";
import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { minimalLayoutRoutes } from "./constants";
declare global {
  interface Window {
    amplitude: any;
    sessionReplay: any;
  }
}
export default function LayoutClientFooter({
  children
}: {
  children?: React.ReactNode;
}) {
  const [jQueryLoaded, setJQueryLoaded] = useState(false);
  const pathname = usePathname();
  const isMinimal = minimalLayoutRoutes.indexOf(pathname) > -1;
  if (isMinimal) {
    return <>{children}</>;
  }
  return <>
            {children}
            <Script src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TAG}`} strategy="afterInteractive" data-sentry-element="Script" data-sentry-source-file="layoutClientFooter.tsx" />
            <Script id="gtag-init" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TAG}', {
              page_path: window.location.pathname + window.location.search,
            });
          `
    }} data-sentry-element="Script" data-sentry-source-file="layoutClientFooter.tsx" />
            <Script src={`https://cdn.amplitude.com/script/${process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY}.js`} strategy="afterInteractive" onLoad={() => {
      if (window.amplitude) {
        window.amplitude.add(window.sessionReplay.plugin({
          sampleRate: 1
        }));
        window.amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY, {
          fetchRemoteConfig: true,
          autocapture: true,
          defaultTracking: {
            sessions: true
          }
        });
      }
    }} data-sentry-element="Script" data-sentry-source-file="layoutClientFooter.tsx" />
            <Script id="branch-api-key" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `window.branchApiKey = "${process.env.NEXT_PUBLIC_BRANCH_API_KEY}";`
    }} data-sentry-element="Script" data-sentry-source-file="layoutClientFooter.tsx" />
            <Script src="/scripts/loadBranch.js" strategy="afterInteractive" onLoad={() => setJQueryLoaded(true)} data-sentry-element="Script" data-sentry-source-file="layoutClientFooter.tsx" />
        </>;
}